import React from "react";
import { Box, Typography } from "@mui/material";

interface CompanyInfo {
  name: string;
  address: string;
  phone: string;
  email: string;
  logo: string;
}

interface ProposalLetterTemplateProps {
  companyInfo: CompanyInfo;
  backgroundPattern?: string;
}

const ProposalLetterTemplate: React.FC<ProposalLetterTemplateProps> = ({
  companyInfo,
  backgroundPattern,
}) => {
  return (
    <Box
      sx={{
        width: "816px",
        minHeight: "100px",
        backgroundImage: backgroundPattern
          ? `url(${backgroundPattern})`
          : "none",
        backgroundRepeat: "repeat",
        backgroundSize: "cover",
        p: 3,
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            src={companyInfo.logo}
            alt="Company Logo"
            sx={{ width: 140, height: 100, mr: 2, mt: 2 }}
          />
        </Box>

        {/* Company Details */}
        <Box sx={{ textAlign: "right", mt: 5 }}>
          <Typography variant="h5" sx={{ color: "white" }}>
            {companyInfo.address}
          </Typography>
          <Typography variant="h5" sx={{ color: "white" }}>
            {companyInfo.phone}
          </Typography>
          <Typography variant="h5" sx={{ color: "white" }}>
            {companyInfo.email}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProposalLetterTemplate;
